<template>
    <div class="faq">
        <div id="preguntas" class="ancla"></div>
        <div class="content">
            <div class="titulo">
                <b-row>
                    <b-col cols="12" md>
                        <div class="linea lineaIzquierda"></div>
                    </b-col>
                    <b-col cols="12" md="auto">
                        <p v-if="lang == 'eng'">RESOURCES</p>
                        <p v-else-if="lang == 'esp'">recursos</p>
                    </b-col>
                    <b-col cols>
                        <div class="linea lineaDerecha"></div>
                    </b-col>
                </b-row>
            </div>
            <h2 v-if="lang == 'eng'">FAQ</h2>
            <h2 v-else-if="lang == 'esp'">Preguntas frecuentes</h2>
        </div>
        <div class="preguntas">
            <div class="contentFaq">
                <b-row>
                    <b-col cols="12" lg="5" xl="4">
                        <img class="imagen" src="../assets/img/img_faq.png" alt="faq">
                    </b-col>
                    <b-col cols="12" lg="7" offset-xl="1">
                        <div class="questions">
                            <div v-for="(data, index) in json" :key="index">
                                <div class="question" :id="'q'+index+1">
                                    <b-button v-b-toggle="String(index+1)" variant="primary" @click="icon(index+1)">
                                        <b-row>
                                            <b-col>
                                                <p v-if="lang == 'eng'">{{data.eng.question}}</p>
                                                <p v-else-if="lang == 'esp'">{{data.esp.question}}</p>
                                            </b-col>
                                            <b-col cols="auto">
                                                <img :id="'more'+(index+1)" src="../assets/img/icn_mas.svg">
                                                <img :id="'less'+(index+1)" class="less" src="../assets/img/icn_menos.svg">
                                            </b-col>
                                        </b-row>
                                    </b-button>
                                    <b-collapse :id="String(index+1)">
                                        <b-card>
                                            <p class="card-text" v-html="data.eng.answer" v-if="lang == 'eng'"></p>
                                            <p class="card-text" v-html="data.esp.answer" v-else-if="lang == 'esp'"></p>
                                        </b-card>
                                    </b-collapse>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapActions, mapMutations} from 'vuex'
    import Faq from './faq.json'
    export default {
        computed:{
            ...mapState(['lang'])
        },
        data(){
            return{
                json: Faq,
            }
        },
        methods: {
            icon(index) {
                const more = 'more'+index
                const less = 'less'+index
                if (document.getElementById(index).classList.contains('show')) {
                    document.getElementById(less).style.display = "none"
                    document.getElementById(more).style.display = "block"
                }
                else{
                    document.getElementById(more).style.display = "none"
                    document.getElementById(less).style.display = "block"
                }
            }
        }
    }
</script>

<style scoped>
    .faq{
        padding-top: 140px;
        position: relative;
    }
    h2{
        margin-bottom: 60px;
        text-align: center;
    }
    .preguntas{
        background-image: url('../assets/img/img_preguntas2.jpg');
        background-repeat: no-repeat;
        background-size: 80% 100%;
        background-position: right center;
        padding: 45px 0 15px 0;
    }
    .contentFaq{
        width: 92.5%;
        margin: 0 auto 0 0;
    }
    .row{
        align-items: center;
    }
    .btn{
        padding: 0!important;
        width: 100%;
        border-radius: inherit;
        text-align: left;
        background-color: transparent!important;
        padding-bottom: 25px!important;
        box-shadow: none!important;
    }
    .btn p{
        margin: 0;
        font-size: 13pt;
    }
    .card{
        border: none!important;
        padding-left: 0;
        padding-right: 0;
        background-color: transparent;
    }
    .card-body{
        padding: 0;
        padding-bottom: 25px;
    }
    p.card-text{
        font-size: 10pt;
    }
    .question{
        border-bottom: 1px solid #068C93;
        margin-bottom: 25px;
    }
    .less{
        display: none;
    }
    img{
        width: 18px;
    }
    .imagen{
        width: 100%;
    }

    @media screen and (max-width: 991px){
        .contentFaq{
            width: 85%;
            margin: 0 auto;
        }
        .imagen{
            margin-bottom: 50px;
        }
        .preguntas{
            background-size: 100% 100%;
        }
    }
    @media screen and (max-width: 767px){
        .faq{
            padding-top: 100px;
        }
        .btn p{
            font-size: 14pt;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/FAQ.vue